///// <reference path="../interfaces/lightsliderconfig.ts" />
module Tapas.ViewModels {
    export class LoginViewModel extends Ftw.ViewModels.BaseViewModel {
        //public User: KnockoutObservable<Ftw.Interfaces.IUser>;
        public Loader: KnockoutObservable<boolean>;
        public ForgottenLoader: KnockoutObservable<boolean>;
        public LoginFailed: KnockoutObservable<boolean>;
        public LoginWrongDomain: KnockoutObservable<boolean>;
        public ToggleForgottenPassword: KnockoutObservable<boolean>;
        public rememberMe: KnockoutObservable<boolean>;
        public email: KnockoutObservable<string>;
        public data: Ftw.Data;
        public confirmation: KnockoutObservable<string>;
        public addFocus: KnockoutObservable<boolean>;
        public loginModal: KnockoutObservable<string>;
        public newUserModal: KnockoutObservable<string>;
        public makeNewUserOpen: KnockoutObservable<boolean>;
        public newUserLoader: KnockoutObservable<boolean>;
        public loginId: KnockoutObservable<number>;
        public successOrFail: KnockoutObservable<boolean>;

        public companyName: KnockoutObservable<string>;
        public contactperson: KnockoutObservable<string>;
        public address1: KnockoutObservable<string>;
        public address2: KnockoutObservable<string>;
        public ean: KnockoutObservable<string>;
        public zip: KnockoutObservable<string>;
        public country: KnockoutObservable<string>;
        public useremail: KnockoutObservable<string>;
        public phone: KnockoutObservable<string>;
        public cvr: KnockoutObservable<string>;
        public group: KnockoutObservable<string>;
        public city: KnockoutObservable<string>;
        public UserName = ko.observable('');
        public Password = ko.observable('');


        public UserDataService: Ftw.Dataservice.UserDataservice;
        private logger = Ftw.Base.Config.Logger;

        private updateZip = (zip: string, city: KnockoutObservable<string>) => {
            return this.data.get("/Handlers/Firstweb.ERP.Users.ashx?cmd=getcity&zipcode=" + zip).then(function (response: IFirstWebERPService) {
                var ERPstatus = response.ERPStatus || null;

                if (ERPstatus) {
                    if (ERPstatus.Success) {
                        city(response.Data); // update City 

                    }
                    else {
                        this.logger.warning("Firstweb.ERP.Users failed with following error code: " + ERPstatus.Code);
                    }
                }
                else {
                    this.logger.warning("ERP status not found in Firstweb.ERP.Users.ashx");
                }
            });
        };


        constructor() {
            super();
            this.UserDataService = new Ftw.Dataservice.UserDataservice();
            //this.User = ko.observable(new Ftw.Dto.User);      
            this.Loader = ko.observable(true);
            this.ForgottenLoader = ko.observable(false);
            this.newUserLoader = ko.observable(false);
            this.LoginFailed = ko.observable(false);
            this.LoginWrongDomain = ko.observable(false);
            this.ToggleForgottenPassword = ko.observable(true);
            //this.GetCurrent();
            this.rememberMe = ko.observable(false);
            this.email = ko.observable('');
            this.data = new Ftw.Data();
            this.confirmation = ko.observable("");
            this.addFocus = ko.observable(false);
            this.makeNewUserOpen = ko.observable(false);
            this.loginModal = ko.observable(".loginModal");
            this.newUserModal = ko.observable(".newUser");
            this.setFocusLogin();
            this.loginId = ko.observable(0);
            this.companyName = ko.observable("");
            this.contactperson = ko.observable("");
            this.useremail = ko.observable("");
            this.phone = ko.observable("");
            this.address1 = ko.observable("");
            this.address2 = ko.observable("");
            this.ean = ko.observable("");
            this.zip = ko.observable("");
            this.country = ko.observable("");
            this.cvr = ko.observable("");
            this.successOrFail = ko.observable(false);
            this.group = ko.observable("");
            this.city = ko.observable("");

            this.zip.subscribe((newZip) => {
                this.updateZip(newZip, this.city); 
            });

        }

        //Set focus when user clicks login
        public setFocusLogin() {
            $(this.loginModal).on("shown.bs.modal", () => {
                this.addFocus(true);
            });
        }

        //Login function, checksfor fails and gives the user a message
        public Login() {
            var login = new Ftw.Dto.LoginRequest(this.UserName(), this.Password(), this.rememberMe());
            this.UserDataService.Login(login).then((user) => {

                if (user.IsLoggedIn()) {
                    this.logger.debug('login successfull');
                    //this.User(user);
                    setTimeout(() =>
                        window.location.reload(),
                        1000);
                } else {
                    this.logger.debug('login failed');
                    this.LoginFailed(true);
                    setTimeout(() =>
                        this.LoginFailed(false),
                        2000);
                } setTimeout(() =>
                    this.Loader(true),
                    2000);
            }).catch((error) => {
                this.logger.debug(error);
            });
        }
        //Recover password function
        public recover() {
            this.ForgottenLoader(true);
            var data = {
                AccessUserEmail: this.email(),
                ForgotPasswordMailTemplate: 'Usermanagement/Login/mail.html',
                ForgotPasswordSenderEmail: 'robot@1stweb.dk',
                ForgotPasswordMailSubject: 'Her er dit password'
            };

            this.data.postForm('/Default.aspx?ID=' + this.loginId + '&LoginAction=Recovery', data)
                .then((data) => {
                    this.confirmation(data);
                    this.ForgottenLoader(false);
                })
                .fail((error) => {
                    this.logger.debug(error);
                });
        }

        //Get the logged in user
        public GetCurrent() {
            this.UserDataService.GetCurrent().then((user) => {
                //this.User(user);                 
            });
        }
        //Logoff function
        public LogOff() {
            this.UserDataService.LogOff().then(() => {
                //this.User(new Ftw.Dto.User);
                window.location.reload();
            });
        }
        //Get all users   
        public GetContacts() {
            this.UserDataService.GetContacts().then((data) => {
            })
        }

        //Make new user popup function
        public newUser() {            

            $('.loginModal').on("hidden.bs.modal", () => {
                $('.newUser').modal('show');

                $('.loginModal').off();
            });

            $('.loginModal').modal('hide');

            this.addFocus(false);
            this.makeNewUserOpen(true);
        }

        public saveNewUser() {
            this.newUserLoader(true);

            var data = {
                company: this.companyName,
                name: this.contactperson,
                vatregnumber: this.cvr,
                address: this.address1,
                address2: this.address2,
                zipcode: this.zip,
                email: this.useremail,
                phone: this.phone,
                ean: this.ean,
                country: this.country,
                groups: this.group,
                city: this.city
            };

            this.data.postForm('/Handlers/Firstweb.ERP.Users.ashx?cmd=createcustomer', data)
                .then((json) => {

                    if (json.ERPStatus.Code != 0) {
                        $('.status').removeClass('show');
                        $('.error-' + json.ERPStatus.Code).addClass('show');
                    } else {
                        $('.status').removeClass('show');
                        this.successOrFail(true);
                    }

                    this.newUserLoader(false);
                })
                .fail((error) => {
                    this.logger.debug(error);
                });
        }
    }
}